// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","zRed":"rgb(237, 85, 100)","outer":"RsJ7","standard":"_2TuB","label":"d56t","inactive":"_1VbX","invalid":"dQ4p"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/components/Input/Textarea/Textarea.scss
// module id = mVp4
// module chunks = 0